import { Component, OnInit, OnDestroy } from '@angular/core';

import { InvoiceModel } from '../../models/invoice.model';
import { InvoiceService } from '../../services/invoice.service';
import { CustomerModel } from '../../models/customer.model';
import { CustomerService } from '../../services/customer.service';

import { IMyDpOptions } from 'mydatepicker';

import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { PackService } from '../../services/pack.service';
import { ApiService } from '../../services/api.service';
import { BikeService2 } from '../../services/bike2.service';
import { ArticleModel } from '../../models/article.model';
import { MagasinService } from '../../services/magasin.service';

@Component({
    selector   : 'my-invoice',
    template: require('./invoice.component.html'),
    styles: [require('./invoice.component.scss')]
})
export class InvoiceComponent implements OnInit, OnDestroy {

    buttonsNew: any;
    buttonsLoad: any;
    invoice: InvoiceModel;
    customerPrivateId: string;
    customer: CustomerModel;

    listModal: any = {
        'generalError': false,
        'delete'      : false,
        'archive'     : false,
        'unarchive'   : false
    };

    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd.mm.yyyy',
        editableDateField: false,
        showInputField: true,
    };


    constructor(public magasinService:MagasinService, public bikeService2: BikeService2, public packService: PackService, public invoiceService: InvoiceService, public customerService: CustomerService, private route: ActivatedRoute, private router: Router, private apiService: ApiService) {
        this.customer = new CustomerModel(customerService);
        this.invoice  = new InvoiceModel(invoiceService);
        this.packService.loadAll();

        this.buttonsNew = {
            'left'  : [],
            'center': [
                {'title'    : 'retour au client',
                    'style' : 'primary',
                    'action': 'returnCustomer',
                    'model' : this,
                    'icon'  : 'fa-arrow-left'
                }
            ],
            'right' : [],
        };

        this.buttonsLoad = {
            'left'  : [
                {'title': 'Imprimer', 'style': 'primary', 'action': 'download', 'model': this, 'icon': 'fa-download'}
            ],
            'center': [
                {'title'    : 'retour au client',
                    'style' : 'primary',
                    'action': 'returnCustomer',
                    'model' : this,
                    'icon'  : 'fa-arrow-left'
                }
            ],
            'right' : [
                {'title'    : 'dupliquer',
                    'style' : 'secondary',
                    'action': 'duplicate',
                    'model' : this,
                    'icon'  : 'fa-files-o'
                },
                {'title': 'supprimer', 'style': 'secondary', 'action': 'openDelete', 'model': this, 'icon': 'fa-trash'},
            ],
        };
    }

    ngOnInit() {
        this.route.params.subscribe(params=> {
            this.customerPrivateId = params['customerPrivateId'];
            this.bikeService2.getAll(this.customerPrivateId);
            if (params['invoicePrivateId']) {
                if (params['duplicate']) {
                    //load une facture
                    this.duplicate(params['invoicePrivateId']);
                } else {
                    //load une facture
                    this.loadInvoice(params['invoicePrivateId']);
                }
            } else {
                //nouvelle facture
                this.loadNewInvoice();
            }
        });
    }

    onDateChanged(_event: any){
        this.invoice.modelChange(null);
    }

    openDelete() {
        this.listModal['delete'] = true;
    }

    paid(){
        if (this.invoice.state != 2)
            return;
        if (this.invoice.paid)
            this.invoice.paid = null;
        else
            this.invoice.paid = new Date();
        this.invoice.modelChange(null);
    }

    openArchive() {
        if (this.invoice.archive)
            this.listModal['unarchive'] = true;
        else
            this.listModal['archive'] = true;
    }

    download() {
        this.apiService.invoicePdf(this.invoice.privateId);
    }

    duplicate(invoicePrivateId: string) {
        if (!invoicePrivateId)
            invoicePrivateId = this.invoice.privateId;
        if (!this.invoice.privateId || this.invoice.validate()) {
            this.invoiceService.duplicate(invoicePrivateId, this.invoice, true);
        }
    }

    loadInvoice(invoicePrivateId: string) {
        this.invoice.articles = [];
        this.invoiceService.load(invoicePrivateId, this.invoice);
    }

    loadNewInvoice() {
        this.invoiceService.loadCustomer(this.customerPrivateId, this.invoice);
        this.invoice.clientPrivateId = this.customerPrivateId;
        this.invoice.generatePublicId();
        this.invoice.addArticle();

        let d                  = new Date();
        this.invoice.whenDay   = d.getDate();
        this.invoice.whenMonth = d.getMonth() + 1;
        this.invoice.whenYear  = d.getFullYear();

        this.invoice.where = this.magasinService.current;
        this.invoice.magasin = this.magasinService.current;
    }

    addBike(bike) {
        let tmp  = new ArticleModel(this.invoice);
        tmp.bike = bike;
        tmp.type = 1;

        this.invoice.articles.push(tmp);
        this.invoice.state = 3;
    }

    addArticle() {
        this.invoice.addArticle();
        //met le focus sur l'input about nouvellement insérer
        try {
            setTimeout(()=> {
                let elements = document.getElementById('articles').getElementsByClassName('article-about');
                elements.item(elements.length - 1).getElementsByTagName('input').item(0).focus();
            }, 100);
        } catch (err) {

        }
    }

    save() {
        if (this.invoice.save()) {

        } else {
            this.listModal['generalError'] = true;
        }
        //this.invoiceService.create(this.invoice);
    }

    returnCustomer() {
        this.router.navigate(['customer', this.customerPrivateId]);
    }

    ngOnDestroy() {

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/invoice/invoice.component.ts